<!-- Loading -->
<div *ngIf="carregando" class="form-card">
  <div class="card-content">
    <div class="estado-inline">
      <i class="pi pi-spinner pi-spin"></i>
      <span>{{ 'contador_operar.config.carregando' | translate }}</span>
    </div>
  </div>
</div>

<!-- Erro -->
<div *ngIf="!carregando && erro" class="form-card">
  <div class="card-content">
    <div class="estado-vazio">
      <i class="pi pi-exclamation-triangle estado-erro-icon"></i>
      <p>{{ 'contador_operar.config.erro_carregar' | translate }}</p>
      <button pButton
        [label]="'contador.dashboard.estados.tentar_novamente' | translate"
        icon="pi pi-refresh"
        class="btn-primary btn-sm"
        (click)="carregar()">
      </button>
    </div>
  </div>
</div>

<!-- Formulario em cards (padrao da tela de Artigos) -->
<form *ngIf="!carregando && !erro" (ngSubmit)="salvar()" class="config-form">

  <!-- Duas colunas de cards, mesmo padrao da aba Timbrado (55% / 45%, empilhando
       abaixo de 992px) — ver timbrado.component.scss:219-236.
       Antes os tres cards eram irmaos diretos do <form> e cada um esticava por
       100% da largura: em 1920px o card "Atividade economica", com um unico
       campo, deixava ~937px de faixa vazia a direita (48,8% da viewport). -->
  <div class="cards-container">

    <div class="column-left">

      <!-- =============== Card: Dados da empresa =============== -->
      <div class="form-card">
        <div class="card-header">
          <div class="card-header-icon">
            <i class="pi pi-building"></i>
          </div>
          <span class="card-header-title">{{ 'contador_operar.config.card_dados' | translate }}</span>
        </div>
        <div class="card-content">
          <div class="config-grid">
            <!-- Nome -->
            <div class="form-item">
              <label>{{ 'contador_operar.config.nome' | translate }} <span class="obrigatorio">*</span></label>
              <input type="text" pInputText
                [(ngModel)]="form.nome" name="nome"
                class="w-full"
                [class.error-field]="submetido && !form.nome.trim()" />
            </div>

            <!-- Nome fantasia -->
            <div class="form-item">
              <label>{{ 'contador_operar.config.fantasia' | translate }} <span class="obrigatorio">*</span></label>
              <input type="text" pInputText
                [(ngModel)]="form.fantasia" name="fantasia"
                class="w-full"
                [class.error-field]="submetido && !form.fantasia.trim()" />
            </div>

            <!-- Endereco -->
            <div class="form-item">
              <label>{{ 'contador_operar.config.endereco' | translate }}</label>
              <input type="text" pInputText [(ngModel)]="form.endereco" name="endereco" class="w-full" />
            </div>

            <!-- Cidade -->
            <div class="form-item">
              <label>{{ 'contador_operar.config.cidade' | translate }}</label>
              <p-dropdown
                [options]="cidadeOptions"
                [(ngModel)]="form.cidadeId"
                name="cidade"
                optionLabel="label"
                optionValue="value"
                [filter]="true"
                [showClear]="true"
                appendTo="body"
                styleClass="w-full"
                [placeholder]="'contador_operar.config.cidade_placeholder' | translate">
              </p-dropdown>
            </div>
          </div>
        </div>
      </div>

      <!-- =============== Card: Atividade econômica =============== -->
      <div class="form-card">
        <div class="card-header">
          <div class="card-header-icon">
            <i class="pi pi-briefcase"></i>
          </div>
          <span class="card-header-title">{{ 'contador_operar.config.card_atividade' | translate }}</span>
        </div>
        <div class="card-content">
          <!-- Unico campo do card: ocupa as duas colunas do .config-grid, ou seja,
               a largura da coluna esquerda (~944px em 1920px). Antes era meio card
               e, como o card ocupava a tela toda, sobrava metade em branco. -->
          <div class="config-grid">
            <div class="form-item form-item-full form-item-atividade">
              <label>{{ 'contador_operar.config.atividade_economica' | translate }}</label>
              <p-multiSelect
                [options]="atividadeOptions"
                [(ngModel)]="form.atividadesEconomicasId"
                name="atividades"
                optionLabel="label"
                optionValue="value"
                [filter]="true"
                appendTo="body"
                styleClass="w-full atividade-multiselect"
                [placeholder]="'contador_operar.config.atividade_placeholder' | translate">
              </p-multiSelect>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="column-right">

      <!-- =============== Card: Faturação eletrônica =============== -->
      <div class="form-card">
        <div class="card-header">
          <div class="card-header-icon">
            <i class="pi pi-file-edit"></i>
          </div>
          <span class="card-header-title">{{ 'contador_operar.config.card_dte' | translate }}</span>
        </div>
        <div class="card-content">
          <div class="config-grid">
            <!-- Codigo de estabelecimento -->
            <div class="form-item">
              <label>{{ 'contador_operar.config.codigo_estabelecimento' | translate }}</label>
              <input type="number" pInputText [(ngModel)]="form.codigoEstabelecimento" name="codigoEstabelecimento" class="w-full" />
            </div>

            <!-- ID CSC -->
            <div class="form-item">
              <label>{{ 'contador_operar.config.id_csc' | translate }}</label>
              <input type="number" pInputText [(ngModel)]="form.idCsc" name="idCsc" class="w-full" />
            </div>

            <!-- CSC -->
            <div class="form-item">
              <label>{{ 'contador_operar.config.csc' | translate }}</label>
              <input type="text" pInputText [(ngModel)]="form.csc" name="csc" autocomplete="off" class="w-full" />
            </div>

            <!-- Senha do certificado -->
            <div class="form-item">
              <label>{{ 'contador_operar.config.senha_certificado' | translate }}</label>
              <p-password
                [(ngModel)]="form.senhaCertificadoDigital"
                name="senhaCertificado"
                [feedback]="false"
                [toggleMask]="true"
                styleClass="w-full"
                inputStyleClass="w-full"
                autocomplete="new-password"
                [placeholder]="'contador_operar.config.senha_certificado_placeholder' | translate">
              </p-password>
            </div>

            <!-- Certificado digital (arquivo) -->
            <div class="form-item form-item-full">
              <label>{{ 'contador_operar.config.certificado' | translate }}</label>
              <div class="certificado-box">
                <input type="file" accept=".pfx,.p12"
                  id="contador-certificado-file"
                  class="certificado-input"
                  (change)="onCertificadoSelecionado($event)" />
                <label for="contador-certificado-file" class="btn-outline btn-sm certificado-btn">
                  <i class="pi pi-upload"></i>
                  {{ 'contador_operar.config.selecionar_certificado' | translate }}
                </label>
                <span class="certificado-info">
                  <ng-container *ngIf="certificadoFile">{{ certificadoFile.name }}</ng-container>
                  <ng-container *ngIf="!certificadoFile && nomeCertificadoAtual">
                    {{ nomeCertificadoAtual }}
                    <small *ngIf="vencimentoCertificadoAtual">
                      ({{ 'contador_operar.config.vence' | translate }} {{ vencimentoCertificadoAtual | date: 'dd/MM/yyyy' }})
                    </small>
                  </ng-container>
                  <ng-container *ngIf="!certificadoFile && !nomeCertificadoAtual">
                    {{ 'contador_operar.config.sem_certificado' | translate }}
                  </ng-container>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

  </div>

  <!-- Acoes -->
  <div class="config-acoes">
    <button pButton type="submit"
      icon="pi pi-check"
      [label]="'contador_operar.config.salvar' | translate"
      class="btn-primary"
      [loading]="salvando"
      [disabled]="salvando">
    </button>
  </div>
</form>
